module.exports = __webpack_public_path__ + "img/munchmakers-logo.1800f70f.webp";